import React, { forwardRef, useEffect, useState } from "react";
import { Provider } from "../../types";
import { ContainerProvider, ComponentProvider, ProviderImage } from "./styles";

type ProviderButtonProps = {
  provider: Provider;
  onClick?: any;
  inSearch?: Boolean;
};

const ProviderButton = forwardRef<HTMLButtonElement, ProviderButtonProps>(
  ({ provider, onClick }, ref) => {
    const [logoUrl, setLogoUrl] = useState(provider.logo_white);

    useEffect(() => {
      setLogoUrl(provider.logo_white);
    }, [provider]);

    const handleInteractionStart = () => setLogoUrl(provider.logo);
    const handleInteractionEnd = () => setLogoUrl(provider.logo_white);

    return (
      <ComponentProvider
        ref={ref}
        id={provider.id}
        onClick={onClick}
        title={provider.name}
        tabIndex={0}
        onMouseEnter={handleInteractionStart}
        onMouseLeave={handleInteractionEnd}
        onTouchStart={handleInteractionStart}
        onTouchEnd={handleInteractionEnd}
        onFocusCapture={handleInteractionStart}
        onBlur={handleInteractionEnd}
      >
        <ContainerProvider>
          <div className="logo">
            <ProviderImage
              alt={`logo da operadora ${provider.name}`}
              src={logoUrl}
            />
          </div>
        </ContainerProvider>
      </ComponentProvider>
    );
  }
);

export default ProviderButton;
